import { Link } from "react-router-dom";

const GalleryCard = (props) => {

    const { proj } = props;

    let bannerImagePath = proj.bannerImageFirebaseRef;
    let projectName = proj.projectName;
    let projectId = proj.projectId;

    return (
        <div className="masonry-grid-item">
            <Link
                to={`/project/${projectId}`}
                style={{ textDecoration: 'none' }}
                state={{ project: proj }}
            >
                <img loading="lazy" className="img-fluid gallery-project-image" src={bannerImagePath} alt="" />
                <figcaption className="img-caption content-0 chocolate">{projectName}</figcaption>
            </Link>
        </div>
    );
}

export default GalleryCard;